import { AbsoluteCenter, Box, CircularProgress } from '@chakra-ui/react';

const Loading = () => {
  return (
    <Box position="relative" w="100vw" h="100vh">
      <AbsoluteCenter>
        <CircularProgress
          size="80px"
          thickness="8px"
          isIndeterminate
        />
      </AbsoluteCenter>
    </Box>
  );
};

export default Loading;